import React from 'react';

import GppBadIcon from '@mui/icons-material/GppBad';
import { Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 64px)',
    backgroundColor: '#f5f5f5',
  },
  card: {
    maxWidth: 500,
    textAlign: 'center',
  },
  icon: {
    fontSize: 60,
    color: '#f44336',
  },
}));

export const GenericError = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Stack sx={{ textAlign: 'center', marginBottom: 2 }}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          marginBottom={2}
        >
          <GppBadIcon className={classes.icon} />
        </Stack>
        <Typography variant='h4' component='h1' fontWeight='bold' gutterBottom>
          Oh no! Something went wrong
        </Typography>
        <Typography
          variant='body1'
          color='textSecondary'
          whiteSpace='pre-line'
          paragraph
        >
          {
            'There was an error getting data from the server.\nPlease try refreshing the page. If the issue persists, contact your system administrator.'
          }
        </Typography>
      </Stack>
    </div>
  );
};